import React from 'react';
import { RadioGroupField, Radio, Flex } from '@aws-amplify/ui-react';

const YesNo = (props) => {

    return (
        <Flex direction="row">
            <RadioGroupField
                value={props.value}
                onChange={props.onChange}
                name={props.name}
                direction="row"
                aria-label={props["aria-label"]}
                >
                {['Nein', 'Ja'].map((item, i) => 
                    <Radio 
                        type="radio"
                        key={`YN_RG_${i}`} 
                        value={i} 
                        disabled={props.value !== i ? props.readOnly : false}
                        aria-checked={props.value === i}
                    >{item}</Radio>)}
            </RadioGroupField>
        </Flex>
    )
}

export default YesNo;